import ChatOutlinedIcon from '@material-ui/icons/ChatOutlined';
import React from 'react';
import { useSelector } from 'react-redux';
import DefaultIcon from './DefaultIcon';

export default function StartStream() {
  const { unreadMessages } = useSelector(({ message }) => ({
    unreadMessages: message.unreadMessages,
  }));
  return (
    <DefaultIcon
      name="Group Chat"
      IconComp={ChatOutlinedIcon}
      hideBadge={unreadMessages <= 0}
      badgeContent={unreadMessages}
      handleClick={() => {
        // setUnreadMessageCount(0)
      }}
    />
  );
}
